import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const ImportProgress = ({ progress, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="mb-3">
      <ProgressBar
        now={progress}
        label={`${progress}%`}
        striped
        animated={progress < 100}
        style={{
          backgroundColor: 'rgba(116, 232, 199, 0.2)',
          borderRadius: '8px',
          height: '20px'
        }}
        variant="success"
      />
    </div>
  );
};

export default ImportProgress;